export const DateTimeToNormalDate = (dateStr) => {
    const date = new Date(dateStr);
  
    const utcOffset = 5 * 60 + 30; // UTC+5:30 in minutes
    const adjustedDate = new Date(date.getTime() + utcOffset * 60 * 1000);
  
    const options = {
      year: 'numeric',
      month: 'short',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    };
    
    const formattedDate = adjustedDate.toLocaleString('en-US', options).replace(',', '');
  
    return formattedDate;
  };
  